/// <amd-module name="SuiteCommerce.ShippingBar.Configuration.Helper"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.ShippingBar.Configuration.Helper", ["require", "exports", "SuiteCommerce.ShippingBar.Common.Configuration", "SuiteCommerce.ShippingBar.Instrumentation", "underscore"], function (require, exports, Configuration_1, Instrumentation_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ConfigurationHelper = /** @class */ (function (_super) {
        __extends(ConfigurationHelper, _super);
        function ConfigurationHelper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ConfigurationHelper.getCurrencyConfig = function () {
            var extensionCurrencyConfiguration = Configuration_1.Configuration.getMultiCurrency();
            var customerSelectedCurrency = Configuration_1.Configuration.getSelectedCurrency();
            var currencyFromConfiguration = customerSelectedCurrency ?
                _.find(extensionCurrencyConfiguration, (function (currency) {
                    return currency.currency === customerSelectedCurrency.internalid;
                })) : null;
            var currencyFoundAtConfiguration = !!currencyFromConfiguration;
            var defaultAmount = Configuration_1.Configuration.shippingGoal();
            var defaultSymbol = Configuration_1.Configuration.currency();
            if (currencyFoundAtConfiguration) {
                var haveSameSymbol = customerSelectedCurrency.symbol === currencyFromConfiguration.currencySymbol;
                if (haveSameSymbol) {
                    return [currencyFromConfiguration.currencySymbol,
                        Number(currencyFromConfiguration.shippingGoalValue),
                        true];
                }
                return [currencyFromConfiguration.currencySymbol,
                    Number(currencyFromConfiguration.shippingGoalValue),
                    false];
            }
            return [defaultSymbol, defaultAmount, false];
        };
        ConfigurationHelper.logCurrencyAndAmount = function () {
            var currencyOptions = this.getCurrencyConfig();
            var log = Instrumentation_1.default.getLog('usage');
            log.setParameters({
                activity: "goal symbol " + currencyOptions[0],
            });
            log.submit();
            log.setParameters({
                activity: "goal amount " + currencyOptions[1],
            });
            log.submit();
        };
        ConfigurationHelper.logHiddenCartBar = function () {
            var showCartBanner = Configuration_1.Configuration.showCartBanner();
            var log = Instrumentation_1.default.getLog('usage');
            if (showCartBanner) {
                log.setParameters({
                    activity: 'shipping bar show cart bar',
                });
            }
            else {
                log.setParameters({
                    activity: 'shipping bar hidden cart bar',
                });
            }
            log.submit();
        };
        ConfigurationHelper.logHiddenDetailBar = function () {
            var showDetailBanner = Configuration_1.Configuration.showDetailBanner();
            var log = Instrumentation_1.default.getLog('usage');
            if (showDetailBanner) {
                log.setParameters({
                    activity: 'shipping bar show PDP bar',
                });
            }
            else {
                log.setParameters({
                    activity: 'shipping bar hidden PDP bar',
                });
            }
            log.submit();
        };
        ConfigurationHelper.logAlternativeCurrecies = function () {
            var _this = this;
            var multiCurrencyList = Configuration_1.Configuration.getMultiCurrency();
            multiCurrencyList.forEach(function (currency) {
                _this.logMulticurrency(currency);
            });
        };
        ConfigurationHelper.logMulticurrency = function (currency) {
            var log = Instrumentation_1.default.getLog('usage');
            log.setParameters({
                activity: "Alternative currency symbol " + currency.currencySymbol,
            });
            log.submit();
            log.setParameters({
                activity: "Alternative currency amount " + currency.shippingGoalValue,
            });
            log.submit();
        };
        return ConfigurationHelper;
    }(Configuration_1.Configuration));
    exports.ConfigurationHelper = ConfigurationHelper;
});
